import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageToken } from '../../util/constant';
import { AccountService } from '../../services/account.service';

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp && payload.exp < now;
  } catch {
    return true;
  }
}

export const tokenInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(LocalStorageToken);

  if (token && !isTokenExpired(token)) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(clonedRequest);
  } else {
    localStorage.removeItem(LocalStorageToken);
    const router = inject(Router);
    const accountService = inject(AccountService);

    accountService.setUser(null);

    const currentUrl = window.location.pathname + window.location.search;

    if (
      !currentUrl.startsWith('/choose-phone-number') &&
      !currentUrl.startsWith('/verify-2fa') &&
      !currentUrl.startsWith('/new-account-setup') &&
      !currentUrl.startsWith('/verify-new-account') &&
      !currentUrl.startsWith('/set-new-password') &&
      !currentUrl.startsWith('/login') &&
      !currentUrl.startsWith('/reset-password') &&
      !currentUrl.startsWith('/reset-password-request')
    ) {
      router.navigate(['/login'], {
        queryParams: { returnUrl: currentUrl },
      });
    }
  }
  return next(req);
};
